import { FOREVER_PASS_GUARANTEE_EXPLANATION } from '@/components/Courses/consts'
import React, { ReactElement } from 'react'
import styles from './PassGuaranteeComponent.module.scss'

export const PassGuaranteeComponent: React.FC<unknown> = (): ReactElement => {
    return (
        <div className={styles.passGuaranteeContainer}>
            <div className={styles.title}>
                All prices include our forever pass guarantee.
            </div>
            {FOREVER_PASS_GUARANTEE_EXPLANATION}
        </div>
    )
}
